import React from 'react'
import './index.css'
import logoPudo from '../../../assets/icons/logo-pudo-alt.png'

let Loader = (props) => (
    <div className={'loader-walk-container'}>
        <img alt="none" src={logoPudo} className={'loader-walk-logo-image'} />
        <div className={'loader-walk'}>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
        <p className={'loader-walk-legend'}>{props.message}</p>
    </div>
)

export default Loader
